/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef, forwardRef } from "react";
import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import { useMediaQuery, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import PrintIcon from "@mui/icons-material/Print";
import Box from "@mui/material/Box";
import logo from "../img/logo.png";
// import bas from "../img/bas.jpg";
import ImageList from "@mui/material/ImageListItem";
import qrcode from "../img/qrcode.jpg";
import moment from "moment";
import Axios from "axios";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { QRCodeCanvas } from "qrcode.react";
import { useDispatch } from "react-redux";
import { logout } from "../../src/store/userSilce";
import CircularProgress from "@mui/material/CircularProgress";
// import {QRCodeSVG} from 'qrcode.react';
require("moment/locale/th");
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function PrintTestScore({
  pers_id,
  mem_rank,
  mem_fname,
  mem_lname,
  testconductdate,
  mem_affiliation,
  mission,
  testresultapprvdate,
  minscore,
  realscore,
  editscore,
  testresultapprv,
  mem_email,
  testappvcode,
  dateappove,
  testreqdate,
  testresvcode,
}) {
  const dispatch = useDispatch();
  const [open, setOpen] = React.useState(false);
  const [getImage, setgetImage] = React.useState([]);
  const [getImageApiRtaf, setgetImageApiRtaf] = React.useState("");
  const [loading, setLoading] = useState(true);
  const { user } = useSelector((state) => state.user);
  // console.log(getImageApiRtaf)
  // const { user } = useSelector((state) => ({ ...state }));
  const token = user.token;
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const getPageMargin = () => {
    return `
  @page {
    size: A4;
    margin: 0mm 0mm 0mm 0mm; /* Adjust the margin values as needed */
    height: 100%;
    width:100%;
    
  }
  @media print {
    body {
      -webkit-print-color-adjust: exact;
      margin: 10mm 5mm 5mm 0mm;
      
    }
    ::after {
      // content: "";
      // background-image: url('${logo}'); 
      // background-repeat: no-repeat;
      // background-size: contain; /* Adjust as needed */
      // position: fixed;
      // top: 50%;
      // left: 50%;
      // right: 50%;
      // transform: translate(-50%, -50%);
      // opacity: 0.008; /* Adjust the opacity of the watermark */
      // width: 100%; /* Set the width of the watermark image */
      // height: 100%; /* Set the height of the watermark image */
      // z-index: -20;
      // filter: blur(9px)
   
    }
   
    }
  `;
  };

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: "emp-data",
    pageStyle: getPageMargin(),
    // onAfterPrint: () => alert("Print success"),
  });

  const date = moment(testreqdate).add(543, "year").format("DD MMMYY");
  // const year = date.substring(7, 9);
  const year = date.slice(-2);
  // console.log("year",year)
  const navigate = useNavigate();
  const AppDate = date.split(" ")[0];
  const AppMouht = date
    .split(" ")[1]
    .substring(0, date.split(" ")[1].length - 2);
  const AppYeay = date.split(".")[2];
  const numbereay = parseInt(AppYeay, 10) + 1;
  const apprvyear = parseInt(moment(AppYeay).add(543, "year").format("YY")) + 1;

  // console.log("testresvcode",testresvcode)
  // console.log("testappvcode",testappvcode)
  // const getImageApi = async () => {
  //   // console.log("realscore",realscore)
  //   await Axios.get(
  //     `https://otp.rtaf.mi.th/api/gateway/VnJOSTl5ZldBQVBkWnlKc2ZkN3NGhGbnhtNFJTVHUzS3BfWlRvd2/personalPicture/${mem_email}/base64`
  //   )
  //     .then((res) => {
  //       setgetImage(res.data);
  //       // console.log("res.data: ",res.data)
  //     })
  //     .catch((err) => {
  //       console.error(err);
  //     });
  // };

  useEffect(() => {
    if (pers_id !== "") {
      // getImageApi();
      var configs = {
        method: "POST",
        url: process.env.REACT_APP_API_URL + `/SendImg/${pers_id}`,
        headers: {
          authtoken: "bearer " + token,
        },
      };
      Axios(configs)
        .then((res) => {
          // console.log("res.data: ",res.data)
          if (res.data !== "noimg") {
            setLoading(false);
            setgetImageApiRtaf(`data:image/jpeg;base64,${res.data}`);
          } else {
            setgetImageApiRtaf(
              "https://upload.wikimedia.org/wikipedia/commons/1/14/No_Image_Available.jpg"
            );
            setLoading(false);
          }
        })
        .catch((err) => {
          if (err.response.status === 401) {
            dispatch(logout());
            navigate("/notfound404", {
              state: {
                statusCode: err.response.status,
                txt: err.response.data,
              },
            });
          } else if (err.response.status === 404) {
            dispatch(logout());
            navigate("/notfound404", {
              state: {
                statusCode: err.response.status,
                txt: err.response.data,
              },
            });
          }
          console.log("getPubrelContents: ", err);
        });
    } else {
      console.log("noper");
    }
  }, [pers_id]);

  const checkScore =
    editscore === null || editscore === 0 ? realscore : editscore;

  const myObjects = {
    pers_id: pers_id,
    date: date,
    // mem_affiliation: mem_affiliation,
    // mission: mission,
    // editscore: editscore,
    // realscore: realscore,
    // AppDate: AppDate,
    // AppMouht: AppMouht,
    // numbereay: numbereay,
    // checkScore: checkScore,
    testresvcode: testresvcode,
    testappvcode: testappvcode,
  };

  const serializedData = JSON.stringify(myObjects);
  // console.log("serializedData",serializedData)
  // const encodedData = encodeURIComponent(serializedData);
  const encodedData = btoa(unescape(encodeURIComponent(serializedData)));

  const testxxx = `https://englishtest.rtaf.mi.th/?data=${encodedData}&from=PrintTestScore`;
  // const testxxx = `192.168.1.122:3000?data=${encodedData}&from=PrintTestScore`;

  const isLargeScreen = useMediaQuery("(min-width: 1200px)"); // lg
  const isMediumScreen = useMediaQuery(
    "(min-width: 960px) and (max-width: 1199px)"
  ); // md
  const isSmallScreen = useMediaQuery(
    "(min-width: 600px) and (max-width: 959px)"
  ); // sm
  const isExtraSmallScreen = useMediaQuery("(max-width: 599px)"); // xs

  return (
    <>
      {testresultapprv === null ? (
        <IconButton>
          <PrintIcon />
        </IconButton>
      ) : (
        <IconButton color="primary" onClick={handleClickOpen}>
          <PrintIcon />
        </IconButton>
      )}

      <Dialog
        fullScreen
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        <AppBar
          sx={{
            position: "relative",
            backgroundColor: "rgba(255, 255, 255, 0.7)",
          }}
          elevation={0}
        >
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon sx={{ color: "#000000" }} />
            </IconButton>
            <Typography
              sx={{ ml: 2, flex: 1, color: "#000000" ,display: {
                xs: "none",  // ซ่อนบนโทรศัพท์
                sm: "none",  // ซ่อนบนแท็บเล็ตเล็ก
                md: "flex",  // แสดงบนหน้าจอกลางขึ้นไป
              },}}
              variant="h6"
              component="div"
            >
              พิมพ์ผลสอบ
            </Typography>
            <Button
            sx={{display: {
              xs: "none",  // ซ่อนบนโทรศัพท์
              sm: "none",  // ซ่อนบนแท็บเล็ตเล็ก
              md: "flex",  // แสดงบนหน้าจอกลางขึ้นไป
            },}}
              autoFocus
              variant="contained"
              className="blob"
              onClick={handlePrint}
            >
              print
            </Button>
          </Toolbar>
        </AppBar>
        <Box sx={{ width: "100%", height: "100%" }} ref={componentRef}>
          <Box
            component="img"
            sx={{
              height: "100%",
              width: "100%",
              filter: "blur(8px)",
              position: "absolute",
            }}
            alt="img"
            src={require(`../img/logo.png`)}
          />

          <Box
            sx={{
              width: "100%",
              position: "absolute",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              marginTop: "0px",
              minHeight: "100vh",
              backgroundColor: "rgba(255, 255, 255,0.7)",
            }}
          >
            <Box
              sx={{
                width: { lg: "740px", md: "740px", sm: "740px", xs: "340px" },
                height: { lg: "100px", md: "100px", sm: "100px", xs: "50px" },
                display: "flex",
                backgroundColor: "rgba(255, 255, 255,0.5)",
                borderStyle: "solid",
                borderWidth: "2px 2px 0px 2px",
                borderColor: "#2F5597",
                marginTop: "15px",
              }}
            >
              <Box>
                <ImageList
                  sx={{
                    width: { lg: "80px", md: "80px", sm: "80px", xs: "40px" },
                    height: { lg: "80px", md: "80px", sm: "80px", xs: "40px" },
                    padding: {
                      lg: "18px 10px 0px 10px",
                      md: "18px 10px 0px 10px",
                      sm: "18px 10px 0px 10px",
                      xs: "9px 5px 0px 4px",
                    },
                  }}
                >
                  <img src={logo} alt="logo" />
                </ImageList>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  flexDirection: "column",
                }}
              >
                <Box>
                  <Typography
                    variant="h5"
                    component="div"
                    sx={{
                      color: "#2F5597",
                      fontWeight: "bold",
                      fontSize: {
                        lg: "26px",
                        md: "26px",
                        sm: "26px",
                        xs: "10px",
                      },
                    }}
                  >
                    ศูนย์ภาษา กรมยุทธศึกษาทหารอากาศ
                  </Typography>
                </Box>
                <Box
                  sx={{
                    width: {
                      lg: "650px",
                      md: "650px",
                      sm: "650px",
                      xs: "290px",
                    },
                    height: { lg: "50px", md: "50px", sm: "50px", xs: "25px" },
                    backgroundColor: "#2F5597",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    variant="body2"
                    component="div"
                    sx={{
                      color: "#ffffff",
                      fontSize: {
                        lg: "26px",
                        md: "26px",
                        sm: "26px",
                        xs: "10px",
                      },
                    }}
                  >
                    รายงานผลคะแนนการทดสอบภาษาอังกฤษ (รายบุคคล)
                  </Typography>
                </Box>
              </Box>
            </Box>
            <Box
              sx={{
                width: { lg: "740px", md: "740px", sm: "740px", xs: "340px" },
                height: { lg: "440px", md: "440px", sm: "440px", xs: "240px" },
                borderStyle: "solid",
                borderWidth: "2px 2px 0px 2px",
                borderColor: "#2F5597",
                display: "flex",
                justifyContent: "space-between",
                backgroundColor: "rgba(255, 255, 255,0.5)",
              }}
            >
              <Box
                sx={{
                  width: { lg: "150px", md: "150px", sm: "150px", xs: "75px" },
                  height: {
                    lg: "350px",
                    md: "350px",
                    sm: "350px",
                    xs: "250px",
                  },
                }}
              >
                <Box>
                  <ImageList
                    sx={{
                      width: {
                        lg: "150px",
                        md: "150px",
                        sm: "150px",
                        xs: "50px",
                      },
                      margin: { lg: "10px", md: "10px", sm: "10px", xs: "5px" },
                    }}
                  >
                    {getImageApiRtaf === "" ? (
                      <CircularProgress
                        sx={{ marginLeft: "50px", marginTop: "50px" }}
                      />
                    ) : (
                      <img src={getImageApiRtaf} alt="logo" />
                    )}
                  </ImageList>
                </Box>
              </Box>

              <Box
                sx={{
                  width: { lg: "295px", md: "295px", sm: "295px", xs: "195px" },
                  height: "100%",
                  display: "flex",
                  justifyContent: "flex-start",
                  flexDirection: "column",
                  marginLeft: { lg: "30px", md: "30px", sm: "30px", xs: "0px" },
                }}
              >
                <Box
                  sx={{
                    margin: { lg: "5px", md: "5px", sm: "5px", xs: "2px" },
                  }}
                >
                  <Typography
                    variant="body2"
                    component="div"
                    sx={{
                      color: "#2F5597",
                      fontSize: {
                        lg: "16px",
                        md: "16px",
                        sm: "16px",
                        xs: "8px",
                      },
                      fontWeight: "bold",
                    }}
                  >
                    ยศ-ชื่อ-นามสกุล
                  </Typography>
                </Box>
                <Box
                  sx={{
                    margin: { lg: "5px", md: "5px", sm: "5px", xs: "2px" },
                  }}
                >
                  <Typography
                    variant="body2"
                    component="div"
                    sx={{
                      color: "#2F5597",
                      fontSize: {
                        lg: "16px",
                        md: "16px",
                        sm: "16px",
                        xs: "8px",
                      },
                    }}
                  >
                    {mem_rank + mem_fname + " " + mem_lname}
                  </Typography>
                </Box>
                <Box
                  sx={{
                    margin: { lg: "5px", md: "5px", sm: "5px", xs: "2px" },
                  }}
                >
                  <Typography
                    variant="body2"
                    component="div"
                    sx={{
                      color: "#2F5597",
                      fontSize: {
                        lg: "16px",
                        md: "16px",
                        sm: "16px",
                        xs: "8px",
                      },
                      fontWeight: "bold",
                    }}
                  >
                    หมายเลขประจำตัวประชาชน
                  </Typography>
                </Box>
                <Box
                  sx={{
                    margin: { lg: "5px", md: "5px", sm: "5px", xs: "2px" },
                  }}
                >
                  <Typography
                    variant="body2"
                    component="div"
                    sx={{
                      color: "#2F5597",
                      fontSize: {
                        lg: "16px",
                        md: "16px",
                        sm: "16px",
                        xs: "8px",
                      },
                    }}
                  >
                    {pers_id}
                  </Typography>
                </Box>
                <Box sx={{ display: "flex" }}>
                  <Box>
                    <Box
                      sx={{
                        margin: { lg: "5px", md: "5px", sm: "5px", xs: "2px" },
                      }}
                    >
                      <Typography
                        variant="body2"
                        component="div"
                        sx={{
                          color: "#2F5597",
                          fontSize: {
                            lg: "16px",
                            md: "16px",
                            sm: "16px",
                            xs: "8px",
                          },
                          fontWeight: "bold",
                        }}
                      >
                        ทดสอบเมื่อ
                      </Typography>
                    </Box>
                    <Box
                      sx={{
                        margin: { lg: "5px", md: "5px", sm: "5px", xs: "2px" },
                      }}
                    >
                      <Typography
                        variant="body2"
                        component="div"
                        sx={{
                          color: "red",
                          fontSize: {
                            lg: "16px",
                            md: "16px",
                            sm: "16px",
                            xs: "8px",
                          },
                        }}
                      >
                        {date === "Invalid date" ? "-" : date}
                      </Typography>
                    </Box>
                  </Box>
                  <Box
                    sx={{
                      marginLeft: {
                        lg: "60px",
                        md: "60px",
                        sm: "60px",
                        xs: "20px",
                      },
                    }}
                  >
                    <Box
                      sx={{
                        margin: { lg: "5px", md: "5px", sm: "5px", xs: "2px" },
                      }}
                    >
                      <Typography
                        variant="body2"
                        component="div"
                        sx={{
                          color: "#2F5597",
                          fontSize: {
                            lg: "16px",
                            md: "16px",
                            sm: "16px",
                            xs: "8px",
                          },
                          fontWeight: "bold",
                        }}
                      >
                        สังกัด
                      </Typography>
                    </Box>
                    <Box
                      sx={{
                        margin: { lg: "5px", md: "5px", sm: "5px", xs: "2px" },
                      }}
                    >
                      <Typography
                        variant="body2"
                        component="div"
                        sx={{
                          color: "#2F5597",
                          fontSize: {
                            lg: "16px",
                            md: "16px",
                            sm: "16px",
                            xs: "8px",
                          },
                        }}
                      >
                        {mem_affiliation}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
                <Box
                  sx={{
                    margin: { lg: "5px", md: "5px", sm: "5px", xs: "2px" },
                  }}
                >
                  <Typography
                    variant="body2"
                    component="div"
                    sx={{
                      color: "#2F5597",
                      fontSize: {
                        lg: "16px",
                        md: "16px",
                        sm: "16px",
                        xs: "8px",
                      },
                      fontWeight: "bold",
                    }}
                  >
                    รายการทดสอบ
                  </Typography>
                </Box>
                <Box
                  sx={{
                    margin: { lg: "5px", md: "5px", sm: "5px", xs: "2px" },
                  }}
                >
                  <Typography
                    variant="body2"
                    component="div"
                    sx={{
                      color: "#2F5597",
                      fontSize: {
                        lg: "16px",
                        md: "16px",
                        sm: "16px",
                        xs: "8px",
                      },
                    }}
                  >
                    {mission === "ทดสอบภาษาอังกฤษประจำปี"
                      ? "โครงการทดสอบความสามารถในการใช้ภาษาอังกฤษของกำลังพล ทอ.ประจำปี " +
                        year +
                        " (สังกัด " +
                        mem_affiliation +
                        ")"
                      : mission}
                  </Typography>
                </Box>
              </Box>

              <Box
                sx={{
                  width: { lg: "295px", md: "295px", sm: "295px", xs: "170px" },
                  height: "100%",
                  display: "flex",
                }}
              >
                <Box
                  sx={{
                    width: { lg: "148px", md: "148px", sm: "148px", xs: "80px" },
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <Box
                    sx={{
                      width: {
                        lg: "148px",
                        md: "148px",
                        sm: "148px",
                        xs: "80px",
                      },
                      height: "20%",
                      backgroundColor: "#2F5597",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      textAlign: "center",
                    }}
                  >
                    <Typography
                      variant="body2"
                      component="div"
                      sx={{
                        color: "#ffffff",
                        fontSize: {
                          lg: "16px",
                          md: "16px",
                          sm: "16px",
                          xs: "8px",
                        },
                      }}
                    >
                      ผลคะแนน <br />
                      การทดสอบ
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      width: {
                        lg: "148px",
                        md: "148px",
                        sm: "148px",
                        xs: "80px",
                      },
                      height: "53.8%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      textAlign: "center",
                      borderStyle: "solid",
                      borderWidth: "2px 2px 0px 2px",
                      borderColor: "#2F5597",
                    }}
                  >
                    <Box sx={{ position: "absolute", filter: "blur(2px)" }}>
                      <ImageList
                        sx={{
                          width: {
                            lg: "80px",
                            md: "80px",
                            sm: "80px",
                            xs: "40px",
                          },
                          height: {
                            lg: "80px",
                            md: "80px",
                            sm: "80px",
                            xs: "40px",
                          },
                        }}
                      >
                        <img
                          src={logo}
                          alt="logo"
                          style={{ filter: "grayscale(100%)" }}
                        />
                      </ImageList>
                    </Box>
                    <Typography
                      variant="body2"
                      component="div"
                      sx={{
                        color: "red",
                        fontSize: {
                          lg: "60px",
                          md: "60px",
                          sm: "60px",
                          xs: "30px",
                        },
                        fontWeight: "bold",
                        zIndex: "9999",
                      }}
                    >
                      {editscore === null || editscore === 0
                        ? realscore
                        : editscore}
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      backgroundColor: "#2F5597",
                      width: {
                        lg: "148px",
                        md: "148px",
                        sm: "148px",
                        xs: "80px",
                      },
                      height: "20%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Typography
                      variant="body2"
                      component="div"
                      sx={{
                        color: "#ffffff",
                        fontSize: {
                          lg: "20px",
                          md: "20px",
                          sm: "20px",
                          xs: "10px",
                        },
                      }}
                    >
                      CEFR <br />
                      LEVEL
                    </Typography>
                  </Box>
                </Box>

                <Box
                  sx={{
                    width: { lg: "147px", md: "147px", sm: "147px", xs: "90px" },
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <Box
                    sx={{
                      width: {
                        lg: "147px",
                        md: "147px",
                        sm: "147px",
                        xs: "90px",
                      },
                      height: { lg: "13.9%", md: "13.9%", sm: "13.9%", xs: "1%" },
                      display: "flex",
                      justifyContent: "center",
                      // marginLeft: "14px",
                      // padding: "5px",
                    }}
                  >
                    {isSmallScreen || isExtraSmallScreen ? (
                      <QRCodeCanvas
                        value={testxxx}
                        size={90}
                        bgColor={"#ffffff"}
                        fgColor={"#000000"}
                        level={"L"}
                        includeMargin={false}
                        imageSettings={{
                          src: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSciNW49eY224gsT55faql5f-AaKfOyeoj9gQ&usqp=CAU",
                          x: undefined,
                          y: undefined,
                          height: 12,
                          width: 12,
                          excavate: true,
                        }}
                      />
                    ) : (
                      <QRCodeCanvas
                        value={testxxx}
                        size={147}
                        bgColor={"#ffffff"}
                        fgColor={"#000000"}
                        level={"L"}
                        includeMargin={false}
                        imageSettings={{
                          src: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSciNW49eY224gsT55faql5f-AaKfOyeoj9gQ&usqp=CAU",
                          x: undefined,
                          y: undefined,
                          height: 24,
                          width: 24,
                          excavate: true,
                        }}
                      />
                    )}
                  </Box>
                  <Box
                    sx={{
                      width: {
                        lg: "147px",
                        md: "147px",
                        sm: "147px",
                        xs: "90px",
                      },
                      height: "10%",
                      backgroundColor: "#000000",
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      marginTop: "88px",
                    }}
                  >
                    <Typography
                      variant="body2"
                      component="div"
                      sx={{
                        color: "#ffffff",
                        fontSize: {
                          lg: "20px",
                          md: "20px",
                          sm: "20px",
                          xs: "10px",
                        },
                      }}
                    >
                      Verified
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      width: {
                        lg: "147px",
                        md: "147px",
                        sm: "147px",
                        xs: "90px",
                      },
                      height: {
                        lg: "30%",
                        md: "30%",
                        sm: "30%",
                        xs: "25.7%",
                      },
                      borderStyle: "solid",
                      borderWidth: "2px 0px 0px 0px",
                      borderColor: "#2F5597",
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      flexDirection: "column",
                    }}
                  >
                    <Typography
                      variant="body2"
                      component="div"
                      sx={{
                        color: "#000000",
                        fontSize: {
                          lg: "20px",
                          md: "20px",
                          sm: "20px",
                          xs: "10px",
                        },
                      }}
                    >
                      ผลคะแนน <br />
                      ใช้ได้ถึง <br />
                    </Typography>
                    <Typography
                      variant="body2"
                      component="div"
                      sx={{
                        color: "red",
                        fontSize: {
                          lg: "20px",
                          md: "20px",
                          sm: "20px",
                          xs: "10px",
                        },
                      }}
                    >
                      {AppDate} {AppMouht}
                      {numbereay}
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      backgroundColor: "#2F5597",
                      width: {
                        lg: "147px",
                        md: "147px",
                        sm: "147px",
                        xs: "90px",
                      },
                      height: {
                        lg: "19.8%",
                        md: "19.8%",
                        sm: "19.8%",
                        xs: "20%",
                      },
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Typography
                      variant="body2"
                      component="div"
                      sx={{
                        color: "#ffffff",
                        fontSize: {
                          lg: "20px",
                          md: "20px",
                          sm: "20px",
                          xs: "10px",
                        },
                      }}
                    >
                      {checkScore >= 10 && checkScore <= 26
                        ? "A1"
                        : checkScore >= 27 && checkScore <= 47
                        ? "A2"
                        : checkScore >= 48 && checkScore <= 77
                        ? "B1"
                        : checkScore >= 78 && checkScore <= 89
                        ? "B2"
                        : checkScore >= 90 && checkScore <= 100
                        ? "C1"
                        : ""}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Box>
            <Box
              sx={{
                width: { lg: "740px", md: "740px", sm: "740px", xs: "340px" },
                height: { lg: "50px", md: "50px", sm: "50px", xs: "25px" },
                borderStyle: "solid",
                borderWidth: "2px",
                borderColor: "#2F5597",
                textAlign: "center",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "rgba(255, 255, 255,0.5)",
              }}
            >
              <Typography
                variant="body2"
                component="div"
                sx={{
                  color: "#2F5597",
                  fontSize: { lg: "12px", md: "12px", sm: "12px", xs: "6px" },
                }}
              >
                เอกสารนี้เป็นเอกสารทางราชการผู้ที่ปลอมแปลงเอกสาร มีโทษตามกฏหมาย
                <br />
                หากมีข้อสงสัยติดต่อ แผนกแผนการศึกษา ศูนย์ภาษา ยศ.ทอ.
                โทร.02-534-2965
              </Typography>
            </Box>
            <Box sx={{ marginTop: "50px" }}>
              <Typography
                variant="body2"
                component="div"
                sx={{
                  color: "#2F5597",
                  fontSize: { lg: "12px", md: "12px", sm: "12px", xs: "8px" },
                }}
              >
                ---------------------------------------------------------------------------------------------------------------------------------------------------------
              </Typography>
            </Box>
          </Box>
        </Box>
      </Dialog>
    </>
  );
}

export default PrintTestScore;
